// 参加者リストの会員ステータス印。申込後に休会・退会した会員も一覧に残すため、在籍以外に印を付ける。
const BADGES = {
  pause: { cls: "member-pause", label: "休会" },
  cancel: { cls: "member-cancel", label: "退会" },
};

export const memberStatusBadge = (status) => BADGES[status] || null;
